import React from 'react';

//Composants
import Title from '../../components/Title/Title';
import ContentText from '../../components/content/content-text.jsx';
import SimpleTitle from '../../components/Title/SimpleTitle';
import Content from '../../components/content/content';
import ContentSlider from '../../components/content/content-slider';
import Skills from '../../components/Projects/Skills.jsx';

//Contenus
import motion from '../../assets/content/projets/motion.json';


const Motiondesign = () => {

    return (
        <div className='projet'>
            <div class="bloc">
                <Title title={motion.title} variant={motion.variant} />
                <ContentText content={motion.description} />


                <div className='content'>
                    <SimpleTitle title="Ma démarche" variant="green" position="left" />
                    <ContentSlider content={motion.partie1} images={motion.slider1} cote={"left"}></ContentSlider>   
                    <ContentSlider content={motion.partie2} images={motion.slider2} cote={"right"}></ContentSlider>

                    <div className='content-text'>
                        <ContentText content={motion.partie3} />
                    </div>

                    <ContentSlider content={motion.partie4} images={motion.slider3} cote={"right"}></ContentSlider>
                    <div className='content-text'>
                        <ContentText content={motion.partie5} />
                    </div>
                </div>
            </div>

            <div className='skills bloc'>
                <SimpleTitle title="Technologies utilisées" variant="white" position="left" />
                <div className='skills-grid'>
                    {motion.technologies.map((tech, index) => (
                    <Skills
                        image={tech.image}
                        alt={tech.alt}
                        competence={tech.name}
                        centered={tech.bool}
                    />
                ))}
                </div>
            </div>
            <div className='competences bloc'>
                <SimpleTitle title="Compétences et apprentissages critiques mobilisés" variant="purple" position="left" />
                <Content content={motion.competences} image={{thumb: motion.imgcompetences,hd: motion.imgcompetencesgrd}} alt={motion.altcompetencesgrd} cote={"left"} width={motion.widthcompetences} height={motion.heightcompetences} title="Illustration des compétences"></Content>
            </div>
            
        </div>
    );
};

export default Motiondesign;